import { Box, Container, Grid, Paper } from '@mui/material'
import s from './TruckSearchDeliveryTicket.modules.scss'
import { TitleHeader } from 'components/shop-reception/mobile/Common/TitleHeader'
import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import { useFormik } from 'formik'
import { initialValues, validationSchema } from './helpers'
import { useNotification } from 'hooks'
import { useMutation, useQuery } from 'react-query'
import { makeCoreGetRequest, makeCorePostRequest } from 'utils/api'
import { formatErrorMessage } from 'utils/formatting'
import { useEffect, useState } from 'react'
import { TruckCard } from 'components/shop-reception/admin/Common/TruckCard'
import { useNavigate } from 'react-router-dom'
import { URLS } from 'components/shop-reception/mobile/constants'

const TruckSearchDeliveryTicket = () => {
  const [truckDetails, setTruckDetails] = useState(null)

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const submitDeliveryTicket = async values => {
    await makeCorePostRequest('/shop-reception-mobile/task-management/truck-unavailable', values)
  }

  const { isLoading, mutate } = useMutation(submitDeliveryTicket, {
    onSuccess: response => {},
    onError: res => {
      showNotification({
        message: `A aparut o eroare la cautarea informatiilor despre BL. ${formatErrorMessage(
          res
        )}`,
        type: 'error'
      })
    }
  })

  const deliveryTicketQuery = useQuery(
    ['truck-delivery-ticket'],
    async () => {
      return await makeCoreGetRequest(
        `/shop-reception-mobile/truck/shop/delivery-tickets/${formik.values.deliveryTicket}`
      )
    },

    {
      initialData: undefined,
      enabled: false,
      keepPreviousData: true,

      onSuccess: data => {
        setTruckDetails(data)
      },
      onError: res => {
        showNotification({
          message: `A aparut o eroare la obtinerea informatiilor despre BL, ${formatErrorMessage(
            res
          )}`,
          type: 'error'
        })
      }
    }
  )

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async values => {
      deliveryTicketQuery.refetch()
    }
  })

  useEffect(() => {
    if (truckDetails && !truckDetails.id) {
      mutate({ deliveryTicket: formik.values.deliveryTicket })
    }
  }, [truckDetails])

  return (
    <Container className={s.gridContainer} maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title="Cautǎ BL" />
        </Grid>
        <Grid item xs={12}>
          <Input
            type="text"
            name="deliveryTicket"
            label="Bon de livrare"
            fullWidth
            variant="outlined"
            value={formik.values.deliveryTicket}
            onChange={event => formik.setFieldValue('deliveryTicket', event.currentTarget.value)}
            error={!!formik.errors.deliveryTicket}
            helperText={formik.errors.deliveryTicket as string}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            type="button"
            variant="contained"
            label="CAUTǍ BL"
            style={{ width: '100%' }}
            onClick={() => formik.handleSubmit()}
          />
        </Grid>
        {truckDetails && truckDetails.id && (
          <Grid item xs={12}>
            <Paper
              elevation={3}
              className={s.truckCard}
              onClick={() => {
                const route = truckDetails?.validTransportCode
                  ? URLS.AUTH_LIST_TRUCKS
                  : URLS.AUTH_ADD_TRUCK
                navigate(route)
              }}
            >
              <Box className={s.truckCardItem}>
                <span>Bon de livrare:</span>
                <span>{truckDetails.externalTicketId}</span>
              </Box>
              <Box className={s.truckCardItem}>
                <span>Cod cursă:</span>
                <span>{truckDetails.transportCode}</span>
              </Box>
              <Box className={s.truckCardItem}>
                <span>Depozit:</span>
                <span>{truckDetails.deposit}</span>
              </Box>
              <Box className={s.truckCardItem}>
                <span>Data:</span>
                <span>{truckDetails.created}</span>
              </Box>
            </Paper>
          </Grid>
        )}
        {truckDetails &&
          truckDetails.id &&
          !truckDetails.validTransportCode &&
          !truckDetails.expired &&
          !truckDetails.forOtherShop &&
          !truckDetails.sentToMeti && (
            <Grid item xs={12}>
              <Box>
                Bonul de livrare găsit are cod de cursă scurt, pentru care trebuie creat manual
                camionul de recepție
              </Box>
              <Box>Faceți click pe cardul cu info BL mai sus pentru a adăuga manual camionul.</Box>
            </Grid>
          )}
        {truckDetails &&
          truckDetails.id &&
          truckDetails?.validTransportCode &&
          !truckDetails?.expired &&
          !truckDetails?.forOtherShop &&
          !truckDetails?.sentToMeti && (
            <Grid item xs={12}>
              <Box>
                Bonul de livrare găsit are cod de cursă lung (TMS), găsiți camionul în lista de
                camioane în așteptare
              </Box>
              <Box>
                Faceți click pe cardul cu info BL mai sus pentru lista de camioane în așteptare.
              </Box>
            </Grid>
          )}
        {truckDetails && truckDetails.id && truckDetails.expired && (
          <Grid item xs={12}>
            <Box>Bonul de livrare este expirat (mai vechi de 4 zile)!</Box>
          </Grid>
        )}
        {truckDetails && truckDetails.id && truckDetails.forOtherShop && (
          <Grid item xs={12}>
            <Box>Bonul de livrare este destinat altui magazin!</Box>
          </Grid>
        )}
        {truckDetails && truckDetails.id && truckDetails.sentToMeti && (
          <Grid item xs={12}>
            <Box>Bonul de livrare este deja integrat în METI!</Box>
          </Grid>
        )}
        {truckDetails && !truckDetails.id && (
          <Grid item xs={12}>
            <Box>Bonul de livrare nu a fost găsit!</Box>
            <Box>Un incident a fost ridicat pentru dvs, in platforma Service Now.</Box>
          </Grid>
        )}
      </Grid>
    </Container>
  )
}

export default TruckSearchDeliveryTicket
